/**
 * @file
 * Global javascripts.
 */
(function ($, Drupal, once) {

  $('.btn-hamburger').on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('is-active');
    if ($('.block--region-navigation_main').hasClass('open')) {
      $('.block--region-navigation_main').removeClass('open');
    }
    else {
      $('.block--region-navigation_main').addClass('open');
    }
  });

  $('.btn-search').on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('is-active');
    if ($('.block--exposed_form_search_global_page_1').hasClass('open')) {
      $('.block--exposed_form_search_global_page_1').removeClass('open');
    }
    else {
      $('.block--exposed_form_search_global_page_1').addClass('open');
    }
  });

  if (!$('body').hasClass('user-logged-in') && $('nav').hasClass('block--region-navigation_main')) {
    var stickymenu = $('.region--navigation-main')[0]
    var stickymenuoffset = stickymenu.offsetTop
    var stickymenuHeight = stickymenu.offsetHeight
    var paddingMain = stickymenuHeight + stickymenuoffset

    window.addEventListener("scroll", function (e) {
      if ($(window).width() > 991) {
      requestAnimationFrame(function () {
        if (window.scrollY > stickymenuoffset) {
          stickymenu.classList.add('fixed')

          $('.layout-container').css({
            paddingTop: paddingMain + 'px',
          });

          $('.region--pre-header').css({
            display: 'none',
          });

          $('.region--header').css({
            display: 'none',
          });

        } else {
          stickymenu.classList.remove('fixed')
          $('.layout-container').css({
            paddingTop: '',
          });

          $('.region--pre-header').css({
            display: 'block',
          });

          $('.region--header').css({
            display: 'block',
          });
        }
      })
       }
    })

  }

  function sidebarMobile() {
    var sidebar = $('.views-sidebar')[0];
    if (sidebar) {
      if (window.innerWidth > 768) {
        sidebar.classList.remove('mobile');
      }
      else {
        sidebar.classList.add('mobile');
      }
    }
  }
  sidebarMobile();
  window.addEventListener('resize', sidebarMobile);

  $(".menu--main a[href^='#']").click(function(event) {

    var $this = $(this),
      target = this.hash,
      $target = $(target);

    const scrollElement = 'html, body';

    $(scrollElement).stop().animate({
      'scrollTop': $target.offset().top-$('.region--header').height(),
    }, 500, 'swing', function() {
      window.location.hash = target; // + ".";
    });

    if ($('.btn-hamburger').hasClass('is-active')) {
      $('.btn-hamburger').removeClass('is-active');
    }

    if ($('.block--main_menu').hasClass('open')) {
      $('.block--main_menu').removeClass('open');
    }

  });


  $("a[href^='#'].scroll").click(function(event) {
    event.preventDefault();

    var $this = $(this),
      target = this.hash,
      $target = $(target);

    const scrollElement = 'html, body';
    var offsetTop = $target.offset().top - 105;
    $target.offset().top = offsetTop;

    $(scrollElement).stop().animate({
      'scrollTop': offsetTop,
    }, 500, 'swing', function() {
      //window.location.hash = target;
      //window.scrollTo.scrollY = offsetTop;
    });

  });

  $('.mobile-buttons .button' ).on('click', function (e) {
    e.preventDefault();
    //$(this).toggleClass('is-active');
    if ($('.views-sidebar').hasClass('open')) {
      $('.views-sidebar').removeClass('open');
    }
    else {
      $('.views-sidebar').addClass('open');
    }
  });

  $('.views-sidebar .close').on('click', function (e) {
    if ($('.views-sidebar').hasClass('open')) {
      $('.views-sidebar').removeClass('open');
    }
  });

  // Drupal.behaviors.offcanvasSidebar = {
  //   attach(context, settings) {
  //     const sidenav = once('offcanvas--sidenav', '#offcanvas--sidenav', context)[0];
  //     const openButton = once('open-sidenav', '#open-sidenav', context)[0];
  //     const closeButton = once('close-sidenav', '#close-sidenav', context)[0];
  //
  //     if (sidenav && openButton && closeButton) {
  //       openButton.addEventListener('click', () => {
  //         sidenav.classList.remove('is-closed');
  //         sidenav.classList.add('is-open');
  //         sidenav.setAttribute('aria-hidden', 'false');
  //       });
  //
  //       closeButton.addEventListener('click', () => {
  //         sidenav.classList.remove('is-open');
  //         sidenav.classList.add('is-closed');
  //         sidenav.setAttribute('aria-hidden', 'true');
  //       });
  //     }
  //   }
  // };

  Drupal.behaviors.responsiveBlockMover = {
    attach(context) {
      const block = once('responsive-block', '.block--region-pre_header', context)[0];
      if (!block) {
        return;
      }

      // Selektory pre regióny definované triedou
      const desktopRegion = document.querySelector('.region--pre-header .container-width');
      const mobileRegion  = document.querySelector('.region--sidenav');

      if (!desktopRegion || !mobileRegion) {
        // Ak triedy neexistujú, skončíme – zabráni to JS chybám v konzole.
        return;
      }

      const moveBlock = () => {
        const toMobile = window.innerWidth < 768;

        if (toMobile && !mobileRegion.contains(block)) {
          mobileRegion.appendChild(block);
        } else if (!toMobile && !desktopRegion.contains(block)) {
          desktopRegion.appendChild(block);
        }
      };

      // Spusti hneď po načítaní
      moveBlock();

      // Reaguj pri zmene veľkosti okna
      window.addEventListener('resize', moveBlock);
    }
  };

  Drupal.behaviors.offcanvasSidenav = {
    attach(context, settings) {
      const sidenav = once('offcanvas--sidenav', '#offcanvas--sidenav', context)[0];
      const openButton = once('open-sidenav', '#open-sidenav', context)[0];
      const closeButton = once('close-sidenav', '#close-sidenav', context)[0];

      if (sidenav && openButton) {
        openButton.addEventListener('click', (event) => {
          event.stopPropagation();
          const isOpen = sidenav.classList.contains('is-open');

          sidenav.classList.toggle('is-open', !isOpen);
          sidenav.classList.toggle('is-closed', isOpen);
          sidenav.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
        });

        closeButton.addEventListener('click', (event) => {
          event.stopPropagation();
          const isOpen = sidenav.classList.contains('is-open');

          sidenav.classList.toggle('is-open', !isOpen);
          sidenav.classList.toggle('is-closed', isOpen);
          sidenav.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
        });

        document.addEventListener('click', (event) => {
          const isClickInside = sidenav.contains(event.target) || openButton.contains(event.target);

          if (!isClickInside && sidenav.classList.contains('is-open')) {
            sidenav.classList.remove('is-open');
            sidenav.classList.add('is-closed');
            sidenav.setAttribute('aria-hidden', 'true');
          }
        });
      }
    }
  };

})(jQuery, Drupal, once);
